// different action types for the different functions

/* * * * * * *  *
* ITEM SPECIFIC *
* * * * * * * * */
// Fetch Conditional requests that only indicate if it was success or fail
export const FETCH_CONDITION_START = 'FETCH_CONDITION_START';
export const FETCH_CONDITION_SUCCESS = 'FETCH_CONDITION_SUCCESS';
export const FETCH_CONDITION_FAIL = 'FETCH_CONDITION_FAIL';
// Fetch Details for Item, Reservation, Order, Price, Contact ...
export const FETCH_DETAILS_START = 'FETCH_DETAILS_START';
export const FETCH_DETAILS_SUCCESS = 'FETCH_DETAILS_SUCCESS';
export const FETCH_DETAILS_FAIL = 'FETCH_DETAILS_FAIL';
// Fetch List/Group of mainTypes, itemTypes, nearbyItems, orders, reservations, order reservations, locations,...
export const FETCH_LIST_START = 'FETCH_LIST_START';
export const FETCH_LIST_SUCCESS = 'FETCH_LIST_SUCCESS';
export const FETCH_LIST_FAIL = 'FETCH_LIST_FAIL';

/* * * * * * *  *
* VIEW SPECIFIC *
* * * * * * * * */
export const SET_GLOBAL_STATE = 'SET_GLOBAL_STATE';
export const TOGGLE_SELECTED_ITEM_TYPES = 'TOGGLE_SELECTED_ITEM_TYPES';
export const SET_ACTIVE_TYPES = 'SET_ACTIVE_TYPES';
export const UPDATE_ITEMS_PAGE = 'UPDATE_ITEMS_PAGE';

/* * * * * * *  *
* NOTIFICATIONS *
* * * * * * * * */
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

/* * * * * * * *
* LOCALIZATION *
* * * * * * *  */
export const SET_LOCALIZATION = 'SET_LOCALIZATION';



// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js